export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.17-1405.26",
  commitId: "b3bcd580e4e6d16253a4cc4327218782bfcfcd60",
  commitTime: "2026-04-17T14:05:26.000Z",
});
